import { GeneralLocaleTypes } from '../locales.types'

const generalLocalePt: GeneralLocaleTypes = {
  username: 'Nome de usuário',
  imageAlt: {},
  status: {
    error: {
      somethingWentWrong: 'Algo deu errado',
      sessionError: 'Indisponível, por favor tente mais tarde...'
    }
  },
  actions: {
    back: 'Voltar',
    cancel: 'Cancelar',
    moveOn: 'Avançar',
    edit: 'Editar',
    delete: 'Apagar',
    remove: 'Remover',
    next: 'Próximo',
    save: 'Salvar {{ addOn }}',
    update: 'Atualizar {{ addOn }}',
    select: 'Selecionar',
    confirm: 'Confirmar',
    revoke: 'Revogar',
    close: 'Fechar'
  },
  or: 'ou'
}

export default generalLocalePt
